import React, { Component } from "react";
import Parse from "parse";
import { Link } from "react-router-dom";
import Header from "../Header/header";
import HeaderContainer from "../Header/LandingHeader/HeaderContainer";
import Footer from "../Footer/footer";
import Chart from "chart.js";
import ReactChartkick, { LineChart } from "react-chartkick";

import { ColShadow, Contentstyled, Layoutstyled } from "../Constants/style";
import { getAvatar } from "../Constants/functions";
import {
  Button,
  DatePicker,
  Divider,
  Form,
  Icon,
  InputNumber,
  message,
  Modal,
  Row,
  Spin
} from "antd";
const moment = require("moment-timezone");

const FormItem = Form.Item;
ReactChartkick.addAdapter(Chart);

moment.locale("fr");

class ClientProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      visible: false
    };
  }

  async componentDidMount() {
    let id = this.props.location.state.id;
    var query = new Parse.Query(Parse.User);
    this.client = await query.get(id);
    this.setState({ loading: false });
  }

  enterWeight = e => {
    var ctx = this;
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        //console.log("client: ", ctx.client)
        var date = moment(values.date).format("LL");
        var arr = [date, values.weight];
        Parse.Cloud.run("setDietWeight", {weight: arr, clientId: ctx.client.id});
        ctx.handleCancel();
        await message.success("Poids sauvegardé !", 1);
        window.location.reload();
      } else {
        message.error("échec de la sauvegarde");
      }
    });
  };

  showModal = () => {
    this.setState({
      visible: true,
    });
  }

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  }

  disabledDate = current => {
    var a = moment();

    // Can not select days after today
    return current > a ;
  };

  getDietButton() {
    //console.log('client: ', this.client);
    if(this.client.attributes.professional === true){
      return null
    }

    if (Parse.User.current().attributes.job === "Diet") {
      const { getFieldDecorator } = this.props.form;

      return (
        <div>
          <Button
            icon="line-chart"
            size="small"
            style={{
              fontSize: "14px",
              color: "#fff",
              backgroundColor: "#0000FE",
              borderColor: "#0000FE",
              margin: "30px 30px"
            }}
            onClick={this.showModal}
          >
            {""} Renseigner le poids du client
          </Button>

          <Modal
            visible={this.state.visible}
            onCancel={this.handleCancel}
            onOk={this.enterWeight}
            okText="Enregistrer"
            cancelText="Annuler"
          >
            <Form onSubmit={this.handleSubmit} className="login-form">
              <FormItem label="Date à laquelle vous avez pesé l'Urban Fitteur">
                {getFieldDecorator("date", {
                  rules: [{ required: true, message: "Indiquez la date" }]
                })(
                  <DatePicker
                    placeholder="Date"
                    format="DD-MM-YYYY"
                    disabledDate={this.disabledDate}
                  />
                )}
              </FormItem>
              <FormItem label="Le poids à la date">
                {getFieldDecorator("weight", {
                  rules: [{ required: true, message: "Indiquez le poids" }]
                })(
                  <InputNumber
                    style={{ paddingLeft: "1px" }}
                    min={1}
                    max={400}
                  />
                )}
              </FormItem>
            </Form>
          </Modal>
        </div>
      );
    } else return null;
  }

  render() {
    if (this.state.loading === true) {
      return (
        <Layoutstyled>
          <Header />
          <HeaderContainer />
          <Contentstyled>
            <Row
              style={{ marginTop: "200px" }}
              type="flex"
              justify="center"
              align="middle"
            >
              <Spin size="large" />
            </Row>
          </Contentstyled>
          <Footer />
        </Layoutstyled>
      );
    }

    var data;
    var weight = this.client.attributes.weight;
    var weightDiet = this.client.attributes.weightDiet;

    if (this.client.attributes.weightDiet !== undefined) {
      data = [
        { name: "Poids mesuré par l'Urban Fitteur", data: weight },
        { name: "Poids mesuré par le Diet", data: weightDiet }
      ];
    } else data = this.client.attributes.weight;

    return (
      <Layoutstyled>
        <Header />
        <HeaderContainer />
        <Contentstyled>
          <Row type="flex" justify="center" align="top">
            <ColShadow
              style={{
                background: "#fff",
                padding: 24,
                radius: 4,
                marginBottom: 35
              }}
              xs={24}
              sm={24}
              md={24}
              lg={6}
              xl={5}
            >
              <img
                src={getAvatar(this.client.attributes)}
                width="128px"
                height="128px"
                alt="profil"
                style={{
                  margin: "15px auto",
                  display: "block",
                  border: "1px solid"
                }}
              />
              <div
                style={{
                  fontWeight: 700,
                  paddingTop: "1vh",
                  textAlign: "center"
                }}
              >
                {" "}
                {this.client.attributes.firstName}{" "}
                {this.client.attributes.lastName} (
                {this.client.attributes.nickName})
              </div>
              <div
                style={{
                  fontSize: "12px",
                  paddingTop: "1vh",
                  fontStyle: "italic",
                  marginBottom: "20px",
                  textAlign: "center"
                }}
              >
                {" "}
              </div>

              <Divider />
              <p>{this.client.attributes.desc}</p>
              <span style={{ fontSize: "12px", fontStyle: "italic" }}>
                membre depuis le{" "}
                {moment(this.client.attributes.createdAt).format("DD/MM/YYYY")}
              </span>
              <Divider />
              <Link to="/team">
                <span
                  style={{
                    fontSize: "13px",
                    fontWeight: "bold",
                    color: "#0000FE",
                    cursor: "pointer"
                  }}
                >
                  <Icon type="double-left" /> Retour vers l'équipe{" "}
                </span>
              </Link>
            </ColShadow>
            <ColShadow
              style={{ background: "#fff", padding: 24, radius: 10 }}
              xs={24}
              sm={24}
              md={24}
              lg={{ span: 16, offset: 1 }}
              xl={{ span: 17, offset: 1 }}
            >
              <h3>Profil de {this.client.attributes.nickName}</h3>
              <Divider style={{ background: "#0000FE" }} className="short" />
              <div>
                <LineChart
                  xtitle="Date"
                  ytitle="Poids"
                  min={30}
                  data={data}
                  colors={["#BF211E", "#F9DC5C"]}
                />

                {this.getDietButton()}
              </div>
            </ColShadow>
          </Row>
        </Contentstyled>
        <Footer />
      </Layoutstyled>
    );
  }
}

const WrappedClientForm = Form.create()(ClientProfile);

export default WrappedClientForm;
